import React, { Component, createRef, Fragment } from 'react'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import axios from 'axios'
import PropTypes from 'prop-types'
import renderHTML from 'react-render-html'
import {LOCALE_STRING_OPTIONS, LOCALE_LANG_OPTIONS} from "../../../utilities/function/common";

const FULL_BULK_SEARCH_CLASSNAME = 'of-full-bulk-search-connector'

class TablePopup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.isActive = this.isActive.bind(this)
    this.renderContent = this.renderContent.bind(this)
    this.onClick = this.onClick.bind(this)
    this.clickOutside = this.clickOutside.bind(this)
    this.onToggleOpen = this.onToggleOpen.bind(this)
    this.onToggleClose = this.onToggleClose.bind(this)
    this.popupRef = createRef()
  }

  isActive () {
    const { item, type } = this.props
    const { eligible_requirement, eligible_requirement_link, id_protection } = item
    if (type === 'id_protection') {
      if (id_protection) {
        return true
      }
      return false
    } else {
      if (eligible_requirement && eligible_requirement_link) {
        return true
      }
      return false
    }
  }

  renderContent () {
    const { type, item } = this.props
    const { eligible_requirement_link } = item
    const getLink = () => {
      if (eligible_requirement_link && eligible_requirement_link.length > 0) {
        const { link_type, internal_link, external_link } = eligible_requirement_link[0]
        return (
          <a className={`table-popup__link clearfix`}
             target={link_type === 'external' ? '_blank' : '_self'}
             href={link_type === 'external' ? external_link : internal_link}>
            View Eligibility Requirements</a>
        )
      }
      return ''
    }
    const link = getLink()

    const { isActive } = this
    if (type === 'id_protection') {
      return (
        <div className={`table-popup__wrapper`}>
          <div className={`table-popup__close icon-of-close icon`} href={null} onClick={() => {
            this.setState({ open: false })
          }}/>
          <div className={`table-popup__description clearfix`}>
            {
              isActive() ?
                'ID Protection will hide your personal details from the public. This domain is eligible for FREE ID Protection.' :
                'Unfortunately due to registry policies, ID protection is unavailable for this domain name.'}
          </div>
        </div>
      )
    } else {
      return (

        <div className={`table-popup__wrapper clearfix`}>
          {/*  <a className={`table-popup__close icon-of-close icon`} href={null} onClick={e => {
            e.preventDefault();
            this.setState({open: false});
          }}/>*/}
          <div className={`table-popup__description clearfix`}>
            {
              isActive() ?
                'There are eligibility requirements that you may need to know about before registering this domain name.' :
                'This domain name does not have strict eligibility requirements'}
          </div>
          <div className={`clear`}></div>
          {isActive() ? link : ''}
        </div>
      )
    }
  }

  clickOutside (e) {
    if (e.target !== this.popupRef.current && !this.popupRef.current.contains(e.target)) {
      this.setState({
        open: false
      })
    }
  }

  onClick () {
    const { open } = this.state
    this.setState({
      open: !open
    })
    document.addEventListener('click', this.clickOutside)
    document.addEventListener('touchstart', this.clickOutside)
  }

  onToggleOpen () {
    this.setState({
      open: true
    })
  }

  onToggleClose () {
    this.setState({
      open: false
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { open } = this.state
    if (prevState.open !== open && open === false) {
      document.removeEventListener('click', this.clickOutside)
      document.removeEventListener('touchstart', this.clickOutside)
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.clickOutside)
    document.removeEventListener('touchstart', this.clickOutside)
  }

  render () {
    const { isActive, renderContent, popupRef, onToggleOpen, onToggleClose } = this
    const { type } = this.props
    const { open } = this.state
    return (
      <div ref={popupRef} className={`table-popup clearfix`}>
        <i onMouseOver={onToggleOpen} onMouseOut={onToggleClose} href={null}
           className={`table-popup__icon icon ${type === 'id_protection' ? ' icon-wp-security-advisor' : ' icon-files-databases'}${isActive() ? ' active' : ''}`}/>
        {open ? renderContent() : ''}
      </div>
    )
  }

}

TablePopup.propTypes = {
  item: PropTypes.any,
  type: PropTypes.any
}

export class FullSearchDomain extends Component {
  constructor () {
    super()
    this.state = {
      domainname_list_by_category: [],
      category: 'popular',
      tab: 'register',
      domainname_subcategory_list: [],
      added_tld: [],
      open_dropdown: false,
      viewport: undefined,
      minHeight: undefined,
      show: false,
      fetching: true
    }
    this.loadDomainNameBasedOnCategory = this.loadDomainNameBasedOnCategory.bind(this)
    this.loadAllDomainNames = this.loadAllDomainNames.bind(this)
    this.loadDomainNameOnSale = this.loadDomainNameOnSale.bind(this)
    this.loadDomainNameSubCategory = this.loadDomainNameSubCategory.bind(this)
    this.loadDomainNamesOnSearch = this.loadDomainNamesOnSearch.bind(this)
    this.isTLDAdded = this.isTLDAdded.bind(this)
    this.addTLD = this.addTLD.bind(this)
    this.removeTLD = this.removeTLD.bind(this)
    this.renderHeadTablePricing = this.renderHeadTablePricing.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
    this.renderPriceValue = this.renderPriceValue.bind(this)
    this.fancyFormOnSubmit = this.fancyFormOnSubmit.bind(this)
    this.cancelTokenSource = null
    this.searchDomainField = createRef()
  }

  clearSearch () {
    this.setState({
      added_tld: [],
      show: false
    })
  }

  computeViewport (width) {
    if (width < 768) {
      return 'xs'
    } else if (width > 767 && width < 992) {
      return 'sm'
    } else if (width > 991 && width < 1200) {
      return 'md'
    } else if (width > 1199) {
      return 'lg'
    }
  }

  componentDidMount () {
    const { category } = this.state
    const { loadDomainNameBasedOnCategory, loadDomainNameSubCategory } = this
    const { computeViewport } = this
    const window_width = window.innerWidth
    const viewport = computeViewport(window_width)
    this.setState({
      ...this.state,
      viewport
    })
    window.addEventListener('resize', () => {
      const window_width = window.innerWidth
      const viewport = computeViewport(window_width)
      this.setState({
        ...this.state,
        viewport
      })
    })
    loadDomainNameBasedOnCategory(category)
    loadDomainNameSubCategory()
  }

  loadDomainNamesOnSearch (input) {
    const { ajax_url } = this.props
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('cancel')
    }
    this.cancelTokenSource = axios.CancelToken.source()
    axios.post(ajax_url, qs.stringify({
      action: 'getDomainNameByKeywordAjax',
      input
    }), {
      cancelToken: this.cancelTokenSource.token
    }).then(response => {
      const { data } = response
      const { domainname_list } = data
      this.setState({
        ...this.state,
        domainname_list_by_category: domainname_list,
        category: 'search'
      })
    }, error => {
      console.log(error)
    })
  }

  componentDidUpdate (prevpops, prevstate) {
    const { viewport, domainname_list_by_category, category } = this.state
    if (domainname_list_by_category !== prevstate.domainname_list_by_category ||
      category !== prevstate.category
    ) {
      if (viewport !== 'xs' && viewport !== 'sm') {
        let sidebarH = document.querySelector('.FullSearchDomain__sidebar .sidebar__list').clientHeight + document.querySelector('.FullSearchDomain__sidebar .sidebar__search-tld').clientHeight
        if (sidebarH > document.querySelector('.FullSearchDomain__content').clientHeight) {
          this.setState({
            ...this.state,
            minHeight: sidebarH
          })
        }
      }
    }
  }

  loadAllDomainNames () {
    const { ajax_url } = this.props
    axios.post(ajax_url, qs.stringify({
      action: 'getAllDomainNameAjax'
    })).then(response => {
      const { data } = response
      const { domainname_list } = data
      this.setState({
        ...this.state,
        domainname_list_by_category: domainname_list,
        category: 'all'
      })
    }, error => {
      console.log(error)
    })
  }

  loadDomainNameBasedOnCategory (category) {
    const { ajax_url } = this.props
    axios.post(ajax_url, qs.stringify({
      action: 'getDomainNameByCategoryAjax',
      category
    })).then(response => {
      const { data } = response
      const { domainname_list_by_category } = data
      const { fetching } = this.state
      if (fetching) {
        this.setState({
          ...this.state,
          domainname_list_by_category,
          category,
          fetching: false
        })
      } else {
        this.setState({
          ...this.state,
          domainname_list_by_category,
          category
        })
      }

    }, error => {
      console.log(error)
    })
  }

  loadDomainNameOnSale () {
    const { ajax_url } = this.props
    axios.post(ajax_url, qs.stringify({
      action: 'getDomainnameOnSaleAjax'
    })).then(response => {
      const { data } = response
      const { domainname_list_on_sale } = data
      this.setState({
        ...this.state,
        domainname_list_by_category: domainname_list_on_sale,
        category: 'onsale'
      })
    }, error => {
      console.log(error)
    })
  }

  loadDomainNameSubCategory () {
    const { ajax_url } = this.props
    axios.post(ajax_url, qs.stringify({
      action: 'getDomainNameSubategoriesAjax'
    })).then(response => {
      const { data } = response
      const { domainname_subcategory_list } = data
      this.setState({
        ...this.state,
        domainname_subcategory_list
      })
    }, error => {
      console.log(error)
    })
  }

  isTLDAdded (tld) {
    let isadded = false
    const { added_tld } = this.state
    if (added_tld && added_tld.length > 0) {
      added_tld.forEach(i => {
        if (i === tld) {
          isadded = true
        }
      })
    }
    return isadded
  }

  addTLD (tld) {
    const { added_tld } = this.state
    let added_tld_temp = Object.assign([], added_tld)
    added_tld_temp.push(tld)
    this.setState({
      ...this.state,
      added_tld: added_tld_temp,
      show: true
    })
  }

  removeTLD (tld) {
    const { added_tld } = this.state
    let added_tld_temp = Object.assign([], added_tld)
    for (var key in added_tld_temp) {
      if (added_tld_temp[key] === tld) {
        added_tld_temp.splice(key, 1)
      }
    }
    this.setState({
      ...this.state,
      added_tld: added_tld_temp
    })
  }

  renderHeadTablePricing () {
    return (
      <div key={'table__row--pricing'}
           className={`table__row clearfix table__row--pricing table__row--pricing-head`}>
        <div className={`table__column table__column--name table__column--name-label clearfix`}>
          EXTENSION
        </div>
        <div className={`table__column table__column--price table__column--label clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}>1 Year</div>
          </div>
        </div>
        <div className={`table__column table__column--price table__column--label clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}>2 Years</div>
          </div>
        </div>
        <div className={`table__column table__column--price table__column--label clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}>3 Years</div>
          </div>
        </div>
        <div className={`table__column table__column--price table__column--label clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}>Transfer</div>
          </div>
        </div>
        <div className={`table__column table__column--price table__column--label clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}>Renew</div>
          </div>
        </div>
        <div className={`table__column table__column--price table__column--label table__column--info clearfix`}>
          <div className={`price__wrapper`}>
            <div className={`price__label`}></div>
          </div>
        </div>
      </div>
    )
  }

  renderPriceValue (value) {
    if (value === 'Free') {
      return (
        <div className={`price__value price__value--free`}>{value}</div>
      )
    }
    return (
      <div className={`price__value`}>${value}</div>
    )
  }

  fancyFormOnSubmit (e) {
    e.preventDefault()
    if (this.searchDomainField && this.searchDomainField.current && this.searchDomainField.current.value) {
      const { history } = this.props
      const { added_tld } = this.state
      let tlds = ''
      if (added_tld && added_tld.length > 0) {
        tlds = encodeURIComponent(added_tld)
      }
      history.push(`${history.location.pathname}?a=add&domain=register&query=${this.searchDomainField.current.value}&tlds=${tlds}`)
    }
  }

  render () {
    const { ordering_site, theme_url, mode, container } = this.props
    const { domainname_list_by_category, category, tab, domainname_subcategory_list, added_tld, viewport, minHeight, show } = this.state
    const { fancyFormOnSubmit, renderPriceValue, renderHeadTablePricing, loadDomainNameBasedOnCategory, loadAllDomainNames, loadDomainNameOnSale, loadDomainNamesOnSearch, isTLDAdded, addTLD, removeTLD } = this
    const renderPrice = (item) => {
      const { register_price, transfer_price, renewal_price, on_sale, old_price } = item
      if (tab === 'register') {
        if (on_sale) {
          return (
            <div className={`table__column table__column--price table__column--sale clearfix`}>
              <div className={`price__wrapper price__wrapper--new`}>
                <div className={`price__value`}>${register_price}</div>
                <div className={`price__period`}>/yr</div>
              </div>
              <div className={`price__wrapper price__wrapper--old`}>
                <div className={`price__value`}>${old_price}</div>
                <div className={`price__period`}>/yr</div>
              </div>
            </div>
          )
        } else {
          return (
            <div className={`table__column table__column--price clearfix`}>
              <div className={`price__wrapper`}>
                <div className={`price__value`}>${register_price}</div>
                <div className={`price__period`}>/yr</div>
              </div>
            </div>
          )
        }
      } else if (tab === 'transfer') {
        return (
          <div className={`table__column table__column--price clearfix`}>
            {transfer_price === 'Free' ?
              <div className={`price__wrapper price__wrapper--free`}>
                <div className={`price__value`}>{transfer_price}</div>
              </div>
              : <div className={`price__wrapper`}>
                <div className={`price__value`}>${transfer_price}</div>
              </div>
            }

          </div>
        )
      } else {
        return (
          <div className={`table__column table__column--price clearfix`}>
            <div className={`price__wrapper`}>
              <div className={`price__value`}>${renewal_price}</div>
              <div className={`price__period`}>/yr</div>
            </div>
          </div>
        )
      }
    }
    const renderName = (item) => {
      const { individual_page, link, name } = item
      if (individual_page) {
        return (<a className={`name__link`} href={link}>{name}</a>)
      } else {
        return (name)
      }
    }
    const renderTableRows = () => {
      if (domainname_list_by_category && domainname_list_by_category.length > 0) {
        if (this.state.category !== 'popular') {
          const collator = new Intl.Collator(undefined, { sensitivity: 'base' })
          domainname_list_by_category.sort((a, b) => collator.compare(a.name, b.name))
        }
        return domainname_list_by_category.map((item, index) => {
          const { name, on_sale } = item
          const isAdded = isTLDAdded(name)
          if (mode === 'pricing' && (viewport !== 'xs')) {
            const {
              register_price,
              transfer_price,
              renewal_price,
              on_sale
            } = item
            return (
              <div key={index} className={`table__row clearfix table__row--pricing`}>
                <div
                  className={`table__column table__column--name table__column--name-pricing clearfix`}>
                  {renderName(item)}{on_sale ?
                  <span className={`name__onsale-tag`}>On Sale</span> : ''}
                </div>
                <div
                  className={`table__column table__column--price table__column--pricing clearfix${on_sale ? ' table__column--onsaleprice' : ''}`}>
                  <div className={`price__wrapper`}>
                    {renderPriceValue(register_price)}
                  </div>
                </div>
                <div
                  className={`table__column table__column--price table__column--pricing clearfix${on_sale ? ' table__column--onsaleprice' : ''}`}>
                  <div className={`price__wrapper`}>
                    {renderPriceValue((register_price * 2).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS))}
                  </div>
                </div>
                <div
                  className={`table__column table__column--price table__column--pricing clearfix${on_sale ? ' table__column--onsaleprice' : ''}`}>
                  <div className={`price__wrapper`}>
                    {renderPriceValue((register_price * 3).toFixed(2))}
                  </div>
                </div>
                <div className={`table__column table__column--price table__column--pricing clearfix`}>
                  <div className={`price__wrapper`}>
                    {renderPriceValue(transfer_price)}
                  </div>
                </div>
                <div className={`table__column table__column--price table__column--pricing clearfix`}>
                  <div className={`price__wrapper`}>
                    {renderPriceValue(renewal_price)}
                  </div>
                </div>
                <div
                  className={`table__column table__column--price table__column--pricing table__column--info clearfix`}>
                  <div className={`icon__wrapper`}>
                    <TablePopup type={`eligibility`} item={item}/>
                    <TablePopup type={`id_protection`} item={item}/>
                  </div>
                </div>
              </div>
            )
          }
          return (
            <div key={index}
                 className={`table__row clearfix${isAdded && tab === 'register' ? ' table__row--added' : ''}`}>
              <div className={`table__column table__column--name clearfix`}>
                {renderName(item)}{on_sale && tab === 'register' ?
                <span className={`name__onsale-tag`}>On Sale</span> : ''}
              </div>
              {renderPrice(item)}
              {tab === 'register' && viewport !== 'xs' ?
                <div className={`table__column table__column--action clearfix`}>
                  <div
                    className={`action__button${isAdded && tab === 'register' ? ' action__button--added' : ''}`}
                    onClick={() => {
                      if (isAdded && tab === 'register') {
                        removeTLD(name)
                      } else {
                        addTLD(name)
                      }
                    }}>
                    {isAdded ? <Fragment><span className={`text text--remove`}>Remove</span><span
                        className="icon-remove1 icon"/></Fragment> :
                      <Fragment><span className={`text text--add`}>Add To Search</span><span className="icon-add icon"/></Fragment>
                    }
                  </div>
                </div> : ''}
            </div>
          )
        })
      } else {
        const { fetching } = this.state
        if (fetching) {
          return (
            <div className={`table__row table__row--loading`}>
              <img className={`spinner z-spinner--css`} src={`${theme_url}/images/zLogo.png`} alt={`zuver loading`}/>
            </div>
          )
        }
        return (
          <div className={`table__row`}>
            <div className={`table__column table__column--noitem`}>
              Sorry. We did not find any results from your search. Try again.
            </div>
          </div>
        )
      }
    }
    const renderSubcategoryItem = () => {
      if (domainname_subcategory_list && domainname_subcategory_list.length > 0) {
        return domainname_subcategory_list.map((item, index) => {
          const { name, slug } = item
          return (
            <li key={index}
                className={`subcategories__item clearfix${category === slug ? ' subcategories__item--active' : ''}`}>
              <div onClick={() => {
                loadDomainNameBasedOnCategory(slug)
              }} className={`item__wrapper clearfix`}>
                {renderHTML(name)}
              </div>
            </li>
          )
        })
      }
    }
    const renderSelectedTlds = () => {
      const renderTLDItem = () => {
        return added_tld.map((item, index) => {
          return (<div onClick={() => {
            removeTLD(item)
          }} key={index} className={`tlds__item`}>
            <span className={`item__text`}>{item}</span>
            <span className={`item__close icon-close`}></span>
          </div>)
        })
      }
      const renderFirstTwoTLDItem = () => {
        return added_tld.map((item, index) => {
          if (index < 2) {
            return (<div key={index} className={`tlds__item`}>
              <span className={`item__text`}>{item}</span>
              <span onClick={() => {
                removeTLD(item)
              }} className={`item__close icon-close`}></span>
            </div>)
          }
          return (<Fragment key={index}/>)
        })
      }
      const renderTLDDropdown = () => {
        const { open_dropdown } = this.state
        let no_dropdown_items = added_tld.length - 2

        class TLDDropdownList extends Component {
          constructor () {
            super()
            this.onClickAwayDropdown = this.onClickAwayDropdown.bind(this)
            this.dropdownRef = null
          }

          onClickAwayDropdown (e) {
            const { parent } = this.props
            if (this.dropdownRef && e.target !== this.dropdownRef && !this.dropdownRef.contains(e.target)) {
              parent.setState({
                ...parent.state,
                open_dropdown: false
              })
            }
          }

          componentDidMount () {
            document.addEventListener('click', this.onClickAwayDropdown)
          }

          componentWillUnmount () {
            document.removeEventListener('click', this.onClickAwayDropdown)
          }

          render () {
            const renderDropdownItem = () => {
              return added_tld.map((item, index) => {
                if (index > 1) {
                  return (<div key={index} onClick={() => {
                    //const {removeTLD} = parent;
                    removeTLD(item)
                  }} className={`dropdown__item`}>
                    <span className={`item__text`}>{item}</span>
                    <span className={`item__close icon-close`}></span>
                  </div>)
                }
                return (<Fragment key={index}/>)
              })
            }
            return (
              <div ref={el => {
                this.dropdownRef = el
              }} className={`dropdown__list clearfix`}>
                {renderDropdownItem()}
              </div>
            )
          }
        }

        TLDDropdownList.propTypes = {
          parent: PropTypes.any
        }
        return (
          <div className={`tlds__dropdown clearfix`}>
            <div onClick={() => {
              this.setState({
                ...this.state,
                open_dropdown: !open_dropdown
              })
            }} className={`dropdown__top clearfix`}>{no_dropdown_items} more
              <div className={`tlds__arrow-wrapper clearfix`}>
                <span className={`icon icon-arrow tlds__arrow`}/>
              </div>
            </div>
            {open_dropdown ? <TLDDropdownList parent={this}/> : ''}
          </div>
        )
      }

      if (added_tld && added_tld.length > 0) {
        if (added_tld.length < 4) {
          return (
            <div className={`tlds__wrapper clearfix`}>
              {renderTLDItem()}
            </div>
          )
        } else {
          return (
            <div className={`tlds__wrapper clearfix`}>
              {renderFirstTwoTLDItem()}
              {renderTLDDropdown()}
            </div>
          )
        }

      } else {
        return ('')
      }
    }
    const renderTLDSInput = () => {
      if (added_tld && added_tld.length > 0) {
        return added_tld.map((item, index) => {
          return (
            <input key={index} type={`hidden`} name={`tlds[]`} value={item}/>
          )
        })
      }
    }
    const renderSidebarMobile = (classname) => {
      const renderList = () => {
        if (domainname_subcategory_list && domainname_subcategory_list.length > 0) {
          return domainname_subcategory_list.map((item, index) => {
            const { name, slug } = item
            return (
              <option key={index} value={`${slug}`}>{renderHTML(name)}</option>
            )
          })
        }
      }
      return (
        <select className={`FullSearchDomain__sidebar-dropdown FullSearchDomain__sidebar-dropdown-${classname}`}
                onChange={e => {
                  e.preventDefault()
                  let cat = e.currentTarget.value
                  if (cat === 'all') {
                    loadAllDomainNames()
                  } else if (cat === 'onsale') {
                    loadDomainNameOnSale()
                  } else {
                    loadDomainNameBasedOnCategory(e.currentTarget.value)
                  }
                }}>
          <option key={`popular`} value={`popular`}>Popular</option>
          <option key={`global`} value={`global`}>Global</option>
          <option key={`aus-and-nz`} value={`aus-and-nz`}>AUS and NZ</option>
          {renderList()}
          <option key={`all`} value={`all`}>All</option>
          <option key={`onsale`} value={`onsale`}>On Sale</option>
        </select>)
    }
    const renderSearchTLDMobile = () => {
      return (
        <form className={`search-tld-mobile clearfix`} onSubmit={e => {
          e.preventDefault()
        }}>
          <div className={`search-tld-mobile__wrapper clearfix`}>
            <input onKeyUp={e => {
              e.preventDefault()
              loadDomainNamesOnSearch(e.currentTarget.value)
            }} onFocus={(e) => {
              e.currentTarget.placeholder = ''
            }} onBlur={(e) => {
              e.currentTarget.placeholder = 'Search Extensions'
            }} className={`search-tld-mobile__textfield`} type={`text`} placeholder={`Search Extensions`}/>
            <button className={`search-tld-mobile__button`}><span className={`icon icon-search`}></span>
            </button>
          </div>
        </form>
      )
    }
    const renderFancyForm = () => {
      if (tab === 'register' && viewport !== 'xs' && show) {
        const { clearSearch } = this
        return (
          <form onSubmit={fancyFormOnSubmit} method={`get`}
                className={`FullSearchDomainFancyForm content__form clearfix`} action={`${ordering_site}/cart.php`}>
            <div className={`container FullSearchDomainFancyForm__container clearfix`}>
              <div className={`FullSearchDomainFancyForm__wrapper clearfix`}>
                <input ref={this.searchDomainField} placeholder={`Start your search here`} name={`query`} type={`text`}
                       className={`FullSearchDomainFancyForm__textfield`} onFocus={(e) => {
                  e.currentTarget.placeholder = ''
                }} onBlur={(e) => {
                  e.currentTarget.placeholder = 'Start your search here'
                }}/>
                {tab === 'register' ? <div
                  className={`FullSearchDomainFancyForm__tlds clearfix`}>{renderSelectedTlds()}</div> : ''}
                {renderTLDSInput()}
                <button className={`FullSearchDomainFancyForm__button`} type="submit"><span
                  className={`icon icon-search`}/></button>
              </div>
              <div className={`FullSearchDomainFancyForm__close clearfix`} onClick={() => {
                clearSearch()
              }}>
                <span className={`text`}>Clear Search</span>
                <span className={`icon icon-close`}/>
              </div>
            </div>
            <input type={`hidden`} name={`a`} value={'add'}/>
            <input type={`hidden`} name={`domain`} value={'register'}/>
          </form>
        )
      }
      return ('')
    }
    return ReactDOM.createPortal(
      <Fragment>
        <div className={`FullSearchDomain FullSearchDomainMore clearfix`}>
          <div className={`FullSearchDomain__sidebar clearfix`}>
            {viewport === 'lg' ? <div className={`FullSearchDomainMore__sidebar-heading`}>Domains and
              Pricing</div> : ''}
            <ul className={`sidebar__list clearfix`}>
              <li className={`list__item clearfix${category === 'popular' ? ' list__item--active' : ''}`}>
                <div onClick={() => {
                  loadDomainNameBasedOnCategory('popular')
                }} className={`item__wrapper`}>Popular
                </div>
              </li>
              <li className={`list__item clearfix${category === 'global' ? ' list__item--active' : ''}`}>
                <div onClick={() => {
                  loadDomainNameBasedOnCategory('global')
                }} className={`item__wrapper`}>Global
                </div>
              </li>
              <li className={`list__item clearfix${category === 'aus-and-nz' ? ' list__item--active' : ''}`}>
                <div onClick={() => {
                  loadDomainNameBasedOnCategory('aus-and-nz')
                }} className={`item__wrapper`}>AUS and NZ
                </div>
              </li>
              <li
                className={`list__item clearfix${category !== 'popular' && category !== 'global' && category !== 'aus-and-nz' && category !== 'all' && category !== 'onsale' && category !== 'search' ? ' list__item--active' : ''}`}>
                {domainname_subcategory_list && domainname_subcategory_list.length > 0 ? <div onClick={() => {
                  const { slug } = domainname_subcategory_list[0]
                  loadDomainNameBasedOnCategory(slug)
                }} className={`item__wrapper clearfix`}>Categories</div> : ''}
                <ul className={`item__subcategories clearfix`}>
                  {renderSubcategoryItem()}
                </ul>
              </li>
              <li className={`list__item clearfix${category === 'all' ? ' list__item--active' : ''}`}>
                <div onClick={() => {
                  loadAllDomainNames()
                }} className={`item__wrapper`}>All Domain Names
                </div>
              </li>
              <li
                className={`list__item list__item--on-sale clearfix${category === 'onsale' ? ' list__item--active' : ''}`}>
                <div onClick={() => {
                  loadDomainNameOnSale()
                }} className={`item__wrapper item__wrapper--onsale`}>On Sale
                </div>
              </li>
            </ul>
            <div className={`sidebar__search-tld clearfix`}>
              <form className={`search-tld__form clearfix`} onSubmit={e => {
                e.preventDefault()
              }}>
                <div className={`search-tld__wrapper clearfix`}>
                  <input onKeyUp={e => {
                    e.preventDefault()
                    loadDomainNamesOnSearch(e.currentTarget.value)
                  }} onFocus={(e) => {
                    e.currentTarget.placeholder = ''
                  }} onBlur={(e) => {
                    e.currentTarget.placeholder = 'Search Extensions'
                  }} className={`search-tld__textfield`} type={`text`} placeholder={`Search Extensions`}

                  />
                  <button className={`search-tld__button`}><span className={`icon icon-search`}></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className={`FullSearchDomain__content clearfix`} style={{
            minHeight: minHeight
          }}>
            <div className={`content__wrapper FullSearchDomainMore__content-wrapper clearfix`}>
              <div className={`content__header clearfix`}>
                <div className={`FullSearchDomainMore__heading clearfix`}>Domains and Pricing</div>
                {mode !== 'pricing' || viewport === 'xs' ? <div className={`header__nav`}>
                  <ul className={`nav__list`}>
                    <li className={`list__item`}>
                      <div onClick={() => {
                        this.setState({
                          ...this.state,
                          tab: 'register'
                        })
                      }}
                           className={`item__wrapper${tab === 'register' ? ' item__wrapper--active' : ''}`}>{viewport === 'xs' ? 'Register' : 'Registration Prices'}</div>
                    </li>
                    <li className={`list__item`}><div onClick={() => {
                      this.setState({
                        ...this.state,
                        tab: 'transfer'
                      })
                    }}
                                                    className={`item__wrapper${tab === 'transfer' ? ' item__wrapper--active' : ''}`}>Transfer</div>
                    </li>
                    <li className={`list__item`}><div onClick={() => {
                      this.setState({
                        ...this.state,
                        tab: 'renewal'
                      })
                    }}
                                                    className={`item__wrapper${tab === 'renewal' ? ' item__wrapper--active' : ''}`}>Renew</div>
                    </li>
                  </ul>
                </div> : ''}{viewport === 'xs' ? renderSidebarMobile('xs') : ''}
              </div>
              <div className={`clear`}/>
              <div className={`FullSearchDomainMore__ipad-sidebar`}>
                {viewport === 'sm' || viewport === 'md' ? renderSidebarMobile('sm') : ''}
                {viewport === 'sm' || viewport === 'md' ? renderSearchTLDMobile('sm') : ''}

              </div>
              <div className={`content__table clearfix`}>
                {mode === 'pricing' && (viewport !== 'xs') ? renderHeadTablePricing() : ''}
                {renderTableRows()}
              </div>
              <div className={`FullSearchDomainMore__terms`}>All prices are shown in Australian currency
                (AUD).
              </div>
            </div>
          </div>
        </div>
        {renderFancyForm()}
      </Fragment>
      , container)
  }
}

FullSearchDomain.propTypes = {
  ordering_site: PropTypes.string,
  theme_url: PropTypes.string,
  mode: PropTypes.string,
  ajax_url: PropTypes.string,
  container: PropTypes.any,
  history: PropTypes.any
}

const FullSearchDomainRouter = withRouter(FullSearchDomain)

export const RenderFullSearchDomain = (props) => {
  const domlist = Array.from(document.querySelectorAll(`.${FULL_BULK_SEARCH_CLASSNAME}`))
  const { router } = props
  if (domlist && domlist.length) {
    return domlist.map((el, index) => {
      const button_label = el.getAttribute('data-button-label')
      const placeholder = el.getAttribute('data-placeholder')
      const transfer = el.getAttribute('data-transfer')
      const ajax_url = el.getAttribute('data-ajax-url')
      const theme_url = el.getAttribute('data-theme-url')
      const ordering_site = el.getAttribute('data-ordering-site')
      return (<FullSearchDomainRouter
        button_label={button_label}
        key={index}
        container={el}
        placeholder={placeholder}
        router={router}
        transfer={transfer}
        ajax_url={ajax_url}
        theme_url={theme_url}
        ordering_site={ordering_site}
      />)
    })
  }
  return (<></>)
}

RenderFullSearchDomain.propTypes = {
  container: PropTypes.any,
  router: PropTypes.any
}